import { useState, useEffect, useRef } from "react";
import autocompleteOptions from "../autocompleteOptions.json";

interface Autocomplete {
  [key: string]: null;
}

const autocomplete = autocompleteOptions as Autocomplete;

function Search() {
  const [search, setSearch] = useState("");
  const [story, setStory] = useState("");
  const storyRef = useRef("");

  function handleSearch(event: React.ChangeEvent<HTMLInputElement>) {
    setSearch(event.target.value);
  }

  function handleSubmit(selectedWord: any) {
    storyRef.current = storyRef.current + " " + selectedWord;
    setStory(storyRef.current);
    setSearch("");
  }

  function clearStory() {
    storyRef.current = "";
    setStory("");
  }

  useEffect(() => {
    const elems = document.querySelectorAll(".autocomplete");
    M.Autocomplete.init(elems, {
      data: autocomplete,
      onAutocomplete: handleSubmit,
    });
  }, []);

  useEffect(() => {
    console.log("story", story);
  }, [story]);

  return (
    <>
      <div className="row">
        <div className="col s12 l6 offset-l3">
          <div className="row">
            <div className="input-field col s12">
              <input
                type="text"
                id="autocomplete-input"
                className="autocomplete"
                value={search}
                onChange={handleSearch}
              />
              <label htmlFor="autocomplete-input">Search</label>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col s12 l6 offset-l3">
          <div className="card horizontal">
            <span
              onClick={clearStory}
              className="btn-floating halfway-fab waves-effect waves-light red"
            >
              <i className="material-icons">delete</i>
            </span>
            <div className="card-stacked">
              <div className="card-content">
                <p className="flow-text">{story}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Search;
